import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { LanguageProvider } from './components/Language.js';
import Home from './pages/home'
import About from './pages/about'
import Contact from './pages/contact'
import Map from './pages/map'
import Nav from './components/navigation'
import ProfileForm from './components/profile.js';
import PageNotFound from './pages/pagenotfound.js'



function App() {
  
  return (
    <BrowserRouter>
    <LanguageProvider>
      {/* <Nav /> */}
      <Routes>
        <Route index element= {<Map />} />
        <Route path='/home' element= {<Home />} />
        {/* <Route path='/about' element= {<About />} />
        <Route path='/contact' element= {<Contact />} />
        <Route path='/map' element= {<Map />} />
        <Route path='/profile/:username' element={<ProfileForm />} /> */}
        <Route path='*' element={<PageNotFound />} />
      </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
